import { FileText, Video, Calendar, Eye, User, Mail, Phone, CreditCard, CheckCircle, ArrowUpDown, RefreshCw, UserCheck } from 'lucide-react';
import { useEffect, useState } from 'react';
import Pagination from '../components/Pagination';

import { GetsuscribeduserInfo, GetAllUser, Getsubscriptionplans, GetUserAdminDetails } from '../components/Api.jsx'; // Add GetUserAdminDetails

// Import modal components
import PDFModal from '../components/dashboard/users/AssignPdf.jsx';
import VideoModel from '../components/dashboard/users/Assignvideo.jsx';
import ModalMeetng from '../components/dashboard/users/AssignMeeting.jsx';
import Modal from '../components/dashboard/users/Modal.jsx'; // Add this import

export default function SubscribersPage() {
  const [subsUser, setSubsUser] = useState([]); // All subscribers
  const [filteredSubs, setFilteredSubs] = useState([]); // Filtered subscribers
  const [searchTerm, setSearchTerm] = useState(''); // Search input
  const [selectedPlan, setSelectedPlan] = useState('all'); // Selected plan filter
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [itemsPerPage, setItemsPerPage] = useState(5); // Items per page, changed default to 5
  const [activeModal, setActiveModal] = useState(null); // Modal type
  const [selectedUserId, setSelectedUserId] = useState(null); // Selected user ID
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' }); // Sorting state
  const [refreshing, setRefreshing] = useState(false); // Refresh state
  const [selectedUser, setSelectedUser] = useState(null); // Add this state for user modal
  const [isModalOpen, setIsModalOpen] = useState(false); // Add this state for user modal

  const fetchSubscribers = async (isRefresh = false) => {
    try {
      if (isRefresh) {
        setRefreshing(true);
      } else {
        setLoading(true);
      }
      setError(null);

      try {
        // Try to get subscribers with subscription info first
        const result = await GetsuscribeduserInfo();
        console.log('Full API Response:', result);
        console.log('API Response Data:', result.data);
        console.log('Data Type:', typeof result.data);
        console.log('Data Structure:', result.data ? Object.keys(result.data) : 'null/undefined');

        let subscribers = [];

        // Check if the response has the expected structure
        if (result.data && result.data.subscriptionsByPlan && Array.isArray(result.data.subscriptionsByPlan)) {
          console.log('Using subscriptionsByPlan structure');
          // Flatten the nested subscriptionsByPlan structure
          subscribers = result.data.subscriptionsByPlan.flatMap(plan => {
            if (!plan || !plan.users || !Array.isArray(plan.users)) {
              return [];
            }
            return plan.users.map(user => ({
              ...user,
              planId: plan.id,
              planName: plan.planName,
            }));
          });
        } else if (result.data && Array.isArray(result.data)) {
          console.log('Using direct array structure');
          // If the response is directly an array of users
          subscribers = result.data;
        } else if (result.data && result.data.data && Array.isArray(result.data.data)) {
          console.log('Using wrapped data structure');
          // If the response is wrapped in a data object
          subscribers = result.data.data;
        } else {
          // If the structure is different, try to get all users and filter for subscribers
          console.warn('Unexpected API response structure, trying alternative approach:', result.data);

          try {
            const allUsersResult = await GetAllUser();
            const subscriptionPlansResult = await Getsubscriptionplans();

            console.log('All Users Result:', allUsersResult.data);
            console.log('Subscription Plans Result:', subscriptionPlansResult.data);

            if (allUsersResult.data && allUsersResult.data.data && Array.isArray(allUsersResult.data.data)) {
              const allUsers = allUsersResult.data.data;
              const subscriptionPlans = subscriptionPlansResult.data || [];

              // Filter users who have subscriptions
              subscribers = allUsers.filter(user =>
                user.subscriptionPlans && user.subscriptionPlans.length > 0
              ).map(user => ({
                ...user,
                planId: user.subscriptionPlans[0]?.id,
                planName: user.subscriptionPlans[0]?.planName || 'Unknown Plan',
              }));
            } else if (allUsersResult.data && Array.isArray(allUsersResult.data)) {
              // Direct array response
              const allUsers = allUsersResult.data;
              subscribers = allUsers.filter(user =>
                user.subscriptionPlans && user.subscriptionPlans.length > 0
              ).map(user => ({
                ...user,
                planId: user.subscriptionPlans[0]?.id,
                planName: user.subscriptionPlans[0]?.planName || 'Unknown Plan',
              }));
            }
          } catch (fallbackError) {
            console.error('Fallback approach also failed:', fallbackError);
            subscribers = [];
          }
        }

        // Fetch detailed user info for each subscriber to get comprehensive subscription data
        const subscribersWithDetails = await Promise.all(
          subscribers.map(async (subscriber) => {
            try {
              const userDetails = await GetUserAdminDetails(subscriber.userId);
              return {
                ...subscriber,
                subscriptions: userDetails.data.data.subscriptions || []
              };
            } catch (error) {
              console.error(`Error fetching details for user ${subscriber.userId}:`, error);
              return {
                ...subscriber,
                subscriptions: []
              };
            }
          })
        );

        // Filter out users who don't have any active subscriptions
        const activeSubscribers = subscribersWithDetails.filter(subscriber => {
          // Check if user has any active subscriptions
          return subscriber.subscriptions &&
            subscriber.subscriptions.some(sub => sub.isActive === true);
        });

        setSubsUser(activeSubscribers);
        setFilteredSubs(activeSubscribers);

      } catch (error) {
        console.error('Error fetching subscribers:', error);
        setError('Failed to load subscribers. Please try again.');
        setSubsUser([]);
        setFilteredSubs([]);
      } finally {
        if (isRefresh) {
          setRefreshing(false);
        } else {
          setLoading(false);
        }
      }
    } catch (error) {
      console.error('Error in fetchSubscribers:', error);
      setError('Failed to load subscribers. Please try again.');
      setSubsUser([]);
      setFilteredSubs([]);
    } finally {
      if (isRefresh) {
        setRefreshing(false);
      } else {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const handleRefresh = () => {
    fetchSubscribers(true);
  };

  // Filter and search logic
  useEffect(() => {
    let filtered = [...subsUser];

    // Filter by plan
    if (selectedPlan !== 'all') {
      filtered = filtered.filter(sub => sub.planName === selectedPlan);
    }

    // Search by username or email
    if (searchTerm) {
      filtered = filtered.filter(sub =>
        (sub.username && sub.username.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (sub.email && sub.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (sub.firstName && sub.firstName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (sub.lastName && sub.lastName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (sub.mobileNumber && sub.mobileNumber.includes(searchTerm))
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      filtered.sort((a, b) => {
        // Handle special cases for nested properties
        let aValue, bValue;

        if (sortConfig.key === 'fullName') {
          aValue = `${a.firstName || ''} ${a.lastName || ''}`.trim().toLowerCase();
          bValue = `${b.firstName || ''} ${b.lastName || ''}`.trim().toLowerCase();
        } else if (sortConfig.key === 'planName') {
          aValue = getActivePlanName(a.subscriptions).toLowerCase();
          bValue = getActivePlanName(b.subscriptions).toLowerCase();
        } else {
          aValue = a[sortConfig.key];
          bValue = b[sortConfig.key];
        }

        // Handle null/undefined values
        if (aValue == null) aValue = '';
        if (bValue == null) bValue = '';

        // Convert to string for comparison if needed
        if (typeof aValue !== 'string') aValue = String(aValue);
        if (typeof bValue !== 'string') bValue = String(bValue);

        // Case insensitive comparison
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();

        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredSubs(filtered);
    setCurrentPage(1); // Reset to first page on filter change
  }, [searchTerm, selectedPlan, subsUser, sortConfig]);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSubs = filteredSubs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredSubs.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const openModal = (modalType, userId) => {
    setSelectedUserId(userId);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
    setSelectedUserId(null);
  };

  // Add these functions for user modal
  const handleUserClick = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const closeUserModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  // Get unique plan names for filter dropdown
  const planOptions = ['all', ...new Set(subsUser.map(sub => sub.planName))];

  // Function to compute full name
  const getFullName = (rowData) => `${rowData.firstName || ''} ${rowData.lastName || ''}`.trim() || 'N/A';

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Function to get subscription status badge
  const getSubscriptionStatusBadge = (isActive) => {
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
        }`}>
        {isActive ? 'Active' : 'Inactive'}
      </span>
    );
  };

  // Function to get active plan name from subscriptions
  const getActivePlanName = (subscriptions) => {
    if (!subscriptions || subscriptions.length === 0) return 'N/A';

    const activeSubscription = subscriptions.find(sub => sub.isActive === true);
    return activeSubscription ? activeSubscription.planName : 'N/A';
  };

  // Function to handle items per page change
  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  // Function to handle sorting
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Function to get sort indicator
  const getSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '↑' : '↓';
    }
    return '';
  };

  return (
    <div className="text-black min-h-screen bg-white p-4">
      {/* Header */}
      <div className="mb-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex flex-col lg:flex-row justify-between gap-6">
            <div className="flex-1">
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-3 rounded-lg">
                  <UserCheck className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="text-gray-600 text-sm leading-relaxed max-w-3xl">
                    View users having a subscription plan and its details. Manage subscriber information, track subscription status, and monitor user engagement.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <button
                onClick={handleRefresh}
                disabled={refreshing}
                className="flex items-center gap-2 px-4 py-2.5 bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white rounded-lg transition-all duration-200 disabled:cursor-not-allowed text-sm font-medium shadow-sm hover:shadow focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                aria-label={refreshing ? "Refreshing data" : "Refresh subscribers data"}
              >
                <RefreshCw className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`} />
                <span>{refreshing ? 'Refreshing...' : 'Refresh'}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Filters and Search */}
      <div className="mb-6 bg-white p-4 rounded-lg shadow-sm border">
        <div className="flex justify-between items-center">
          <div className="relative w-1/3">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search subscribers..."
              className="w-full px-4 py-2 pl-10 pr-4 text-black border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>

        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mr-3"></div>
          <span className="text-gray-600">Loading subscribers...</span>
        </div>
      )}

      {/* Error State */}
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg mb-6">
          <p>{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
          >
            Retry
          </button>
        </div>
      )}

      {/* Subscribers Table */}
      {!loading && !error && (
        <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    S.No
                  </th>
                  <th
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('fullName')}
                  >
                    <div className="flex items-center">
                      Subscriber Name
                      <ArrowUpDown className="ml-1 w-4 h-4" />
                      <span className="ml-1">{getSortIndicator('fullName')}</span>
                    </div>
                  </th>
                  <th
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('email')}
                  >
                    <div className="flex items-center">
                      Contact
                      <ArrowUpDown className="ml-1 w-4 h-4" />
                      <span className="ml-1">{getSortIndicator('email')}</span>
                    </div>
                  </th>
                  <th
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('planName')}
                  >
                    <div className="flex items-center">
                      Plan
                      <ArrowUpDown className="ml-1 w-4 h-4" />
                      <span className="ml-1">{getSortIndicator('planName')}</span>
                    </div>
                  </th>
                  <th
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('isActive')}
                  >
                    <div className="flex items-center">
                      Status
                      <ArrowUpDown className="ml-1 w-4 h-4" />
                      <span className="ml-1">{getSortIndicator('isActive')}</span>
                    </div>
                  </th>
                  <th
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('createdAt')}
                  >
                    <div className="flex items-center">
                      Joined
                      <ArrowUpDown className="ml-1 w-4 h-4" />
                      <span className="ml-1">{getSortIndicator('createdAt')}</span>
                    </div>
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {currentSubs.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="px-6 py-8 text-center text-gray-500">
                      <div className="flex flex-col items-center">
                        <User className="w-12 h-12 text-gray-400 mb-2" />
                        <p className="text-lg font-medium">
                          {subsUser.length === 0 ? 'No subscribers found' : 'No subscribers match your search'}
                        </p>
                        <p className="text-sm text-gray-400 mt-1">Try adjusting your search terms</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  currentSubs.map((sub, index) => (
                    <tr key={sub.userId || index} className="hover:bg-gray-50 transition-colors">
                      <td className="px-4 py-4 text-sm text-gray-500 font-mono">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      {/* Subscriber Details */}
                      <td className="px-4 py-4">
                        <div className="flex flex-col">
                          <div className="text-sm font-medium text-gray-900">
                            {getFullName(sub)}
                          </div>
                        </div>
                      </td>

                      {/* Contact */}
                      <td className="px-4 py-4">
                        <div className="flex flex-col">
                          <div className="flex items-center text-sm text-gray-900">
                            <Mail className="w-4 h-4 mr-1 text-gray-400" />
                            {sub.email}
                          </div>
                          <div className="flex items-center text-xs text-gray-500 mt-1">
                            <Phone className="w-3 h-3 mr-1 text-gray-400" />
                            {sub.mobileNumber || 'N/A'}
                          </div>
                        </div>
                      </td>

                      {/* Plan */}
                      <td className="px-4 py-4">
                        <div className="text-sm text-gray-900">
                          {getActivePlanName(sub.subscriptions)}
                        </div>
                      </td>

                      {/* Status */}
                      <td className="px-4 py-4">
                        {getSubscriptionStatusBadge(sub.isActive !== false)}
                      </td>

                      {/* Joined Date */}
                      <td className="px-4 py-4">
                        <div className="flex items-center text-sm text-gray-900">
                          <Calendar className="w-4 h-4 mr-1 text-gray-400" />
                          {formatDate(sub.createdAt)}
                        </div>
                      </td>

                      {/* Actions */}
                      <td className="px-4 py-4">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => handleUserClick(sub)} // Update this line
                            className="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-600 bg-blue-100 rounded hover:bg-blue-200 transition-colors"
                          >
                            <Eye className="w-3 h-3 mr-1" />
                            View
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        totalElements={filteredSubs.length}
        pageSize={itemsPerPage}
        setPageSize={setItemsPerPage}
        itemName="Subscribers"
      />

      {/* Modals */}
      <PDFModal
        isOpen={activeModal === 'pdf'}
        closeModal={closeModal}
        userId={selectedUserId}
      />
      <VideoModel
        isOpen={activeModal === 'video'}
        closeModal={closeModal}
        userId={selectedUserId}
      />
      <ModalMeetng
        isOpen={activeModal === 'meeting'}
        closeModal={closeModal}
        userId={selectedUserId}
      />
      {isModalOpen && selectedUser && ( // Add this block
        <Modal user={selectedUser} onClose={closeUserModal} />
      )}
    </div>
  );
}